import React from 'react';
import YouTube from 'react-youtube';
import { SliceContext } from 'components/Slices/types';
import { withAppContext, AppContextType } from 'context/AppContext';
import { SegmentService } from 'analytics';

type YoutubeVideoProps = {
    videoId: string;
    className?: string;
    autoplay?: boolean;
    slice?: SliceContext;
    context: AppContextType;
};

type YoutubeVideoState = {
    isMounted: boolean;
};

class YoutubeVideoComponent extends React.Component<YoutubeVideoProps, YoutubeVideoState> {
    allreadyPlayed = false;
    state = { isMounted: false };

    componentDidMount() {
        this.setState({ isMounted: true });
    }

    onPlaying = () => {
        if (!this.allreadyPlayed) {
            SegmentService.trackVideoPlayed({ 'L - Video Name': this.props.videoId }, this.props.slice);
            this.allreadyPlayed = true;
        }
    };

    render() {
        if (!this.state.isMounted) {
            return null;
        }

        const opts: any = {
            height: '100%',
            width: '100%',
            playerVars: {
                autoplay: this.props.autoplay ? 1 : 0,
                showinfo: 0,
                autohide: 1,
                modestbranding: 1,
                rel: 0,
            },
        };

        const { videoId } = this.props;

        return (
            <div className="Video-wrapper" data-testid="youtube-embedded-player">
                <YouTube containerClassName="Iframe-wrapper" videoId={videoId} opts={opts} onPlay={this.onPlaying} />
            </div>
        );
    }
}
const YoutubeVideo = withAppContext(YoutubeVideoComponent);

export { YoutubeVideo, YoutubeVideoComponent, YoutubeVideoProps };
